import React from 'react';
import classNames from 'classnames';

import css from './IconModify.module.css';

/**
 * Magnifier icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconModify = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg className={classes} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.54396 15.4493L1.00586 17L2.55653 11.4619L12.6974 1.37028C12.812 1.25307 12.949 1.15993 13.1 1.09634C13.2511 1.03275 13.4134 1 13.5773 1C13.7413 1 13.9036 1.03275 14.0547 1.09634C14.2057 1.15993 14.3427 1.25307 14.4573 1.37028L16.6356 3.56091C16.7509 3.67531 16.8425 3.81144 16.905 3.9614C16.9675 4.11137 16.9996 4.27223 16.9996 4.4347C16.9996 4.59716 16.9675 4.75802 16.905 4.90799C16.8425 5.05797 16.7509 5.19408 16.6356 5.30849L6.54396 15.4493Z" stroke="#6E7191" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default IconModify;
